"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Analytics = exports.createAnalyticsInstance = void 0;
var growthbook_1 = require("./growthbook");
var rudderstack_1 = require("./rudderstack");
function createAnalyticsInstance(options) {
    var _growthbook, _rudderstack, core_data = {}, cta_buttons = {}, offline_cache = {};
    var interval = setInterval(function () {
        if (Object.keys(cta_buttons).length > 0)
            clearInterval(interval);
        else
            cta_buttons = getFeatureValue('tracking-buttons-config', {});
    }, 1000);
    var initialise = function (_a) {
        var growthbookKey = _a.growthbookKey, growthbookDecryptionKey = _a.growthbookDecryptionKey, rudderstackKey = _a.rudderstackKey;
        _rudderstack = rudderstack_1.RudderStack.getRudderStackInstance(rudderstackKey);
        if (growthbookKey && growthbookDecryptionKey) {
            _growthbook = growthbook_1.Growthbook.getGrowthBookInstance(growthbookKey, growthbookDecryptionKey);
        }
    };
    var setAttributes = function (_a) {
        var country = _a.country, user_language = _a.user_language, device_language = _a.device_language, device_type = _a.device_type, account_type = _a.account_type, user_id = _a.user_id, app_id = _a.app_id, utm_source = _a.utm_source, utm_medium = _a.utm_medium, utm_campaign = _a.utm_campaign, is_authorised = _a.is_authorised;
        if (!_growthbook && !_rudderstack)
            return;
        var user_identity = user_id ? user_id : getId();
        // Check if we have Growthbook instance
        if (_growthbook) {
            _growthbook.setAttributes({
                id: user_identity || getId(),
                country: country,
                user_language: user_language,
                device_language: device_language,
                device_type: device_type,
                utm_source: utm_source,
                utm_medium: utm_medium,
                utm_campaign: utm_campaign,
                is_authorised: is_authorised,
            });
        }
        core_data = __assign(__assign(__assign(__assign(__assign({}, (user_language !== undefined && { user_language: user_language })), (account_type !== undefined && { account_type: account_type })), (app_id !== undefined && { app_id: app_id })), (device_type !== undefined && { device_type: device_type })), (user_identity !== undefined && { user_identity: user_identity }));
    };
    var getFeatureState = function (id) { var _a, _b; return (_b = (_a = _growthbook === null || _growthbook === void 0 ? void 0 : _growthbook.getFeatureState(id)) === null || _a === void 0 ? void 0 : _a.experimentResult) === null || _b === void 0 ? void 0 : _b.name; };
    var getFeatureValue = function (id, defaultValue) { return _growthbook === null || _growthbook === void 0 ? void 0 : _growthbook.getFeatureValue(id, defaultValue); };
    var isFeatureOn = function (key) { return _growthbook === null || _growthbook === void 0 ? void 0 : _growthbook.isOn(key); };
    var setUrl = function (href) { return _growthbook === null || _growthbook === void 0 ? void 0 : _growthbook.setUrl(href); };
    var getId = function () { return (_rudderstack === null || _rudderstack === void 0 ? void 0 : _rudderstack.getUserId()) || (_rudderstack === null || _rudderstack === void 0 ? void 0 : _rudderstack.getAnonymousId()); };
    /**
     * Pushes page view event to Rudderstack
     *
     * @param curret_page The name or URL of the current page to track the page view event
     */
    var pageView = function (current_page, platform) {
        if (platform === void 0) { platform = 'Deriv App'; }
        if (!_rudderstack)
            return;
        _rudderstack === null || _rudderstack === void 0 ? void 0 : _rudderstack.pageView(current_page, platform, getId());
    };
    var identifyEvent = function () {
        if ((core_data === null || core_data === void 0 ? void 0 : core_data.user_identity) && _rudderstack) {
            _rudderstack === null || _rudderstack === void 0 ? void 0 : _rudderstack.identifyEvent(core_data === null || core_data === void 0 ? void 0 : core_data.user_identity, { language: (core_data === null || core_data === void 0 ? void 0 : core_data.user_language) || 'en' });
        }
    };
    var reset = function () {
        if (!_rudderstack)
            return;
        _rudderstack === null || _rudderstack === void 0 ? void 0 : _rudderstack.reset();
    };
    var trackEvent = function (event, analytics_data) {
        if (!_rudderstack)
            return;
        if (navigator.onLine) {
            if (Object.keys(offline_cache).length > 0) {
                Object.keys(offline_cache).map(function (cache) {
                    _rudderstack.track(offline_cache[cache].event, offline_cache[cache].payload);
                    delete offline_cache[cache];
                });
            }
            if (event in cta_buttons) {
                // @ts-ignore
                cta_buttons[event] && (_rudderstack === null || _rudderstack === void 0 ? void 0 : _rudderstack.track(event, __assign(__assign({}, core_data), analytics_data)));
            }
            else
                _rudderstack === null || _rudderstack === void 0 ? void 0 : _rudderstack.track(event, __assign(__assign({}, core_data), analytics_data));
        }
        else {
            offline_cache[event + analytics_data.action] = { event: event, payload: __assign(__assign({}, core_data), analytics_data) };
        }
    };
    var getInstances = function () { return ({ ab: _growthbook, tracking: _rudderstack }); };
    return {
        initialise: initialise,
        setAttributes: setAttributes,
        identifyEvent: identifyEvent,
        getFeatureState: getFeatureState,
        getFeatureValue: getFeatureValue,
        isFeatureOn: isFeatureOn,
        setUrl: setUrl,
        getId: getId,
        trackEvent: trackEvent,
        getInstances: getInstances,
        pageView: pageView,
        reset: reset,
    };
}
exports.createAnalyticsInstance = createAnalyticsInstance;
exports.Analytics = createAnalyticsInstance();
